import { TEMPLATE_WIDTH } from "../emailTemplateConstants";

export const getEmailTableCell = ({
  label,
  value,
  width,
  widthPercentage,
  index,
  length,
  dataTestId,
}) => `
    <!--[if mso | IE]>${
      index === 0
        ? `<table role="presentation" border="0" cellpadding="0" cellspacing="0">`
        : ""
    }<tr><td class="" style="vertical-align:top;width:${
  width - 0.5
}px;" ><![endif]-->
                <div
                  class="mj-column-per-${Math.floor(
                    widthPercentage
                  )} mj-outlook-group-fix"
                  style="
                    font-size: 0px;
                    text-align: left;
                    direction: ltr;
                    display: inline-block;
                    vertical-align: top;
                    width: 100%;
                    min-height: 60px;
                    box-sizing: border-box;
                    ${
                      index + 1 === length
                        ? ""
                        : "border-right: 1px solid #e0e0e0;"
                    }
                  "
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    width="100%"
                  >
                    <tbody>
                      <tr>
                        <td
                          style="
                            vertical-align: top;
                            padding: 0;
                          "
                        >
                          <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style
                            width="100%"
                            data-testid="${dataTestId}"
                          >
                            <tbody>
                              <tr>
                                <td
                                  align="left"
                                  style="
                                    font-size: 0px;
                                    padding: 10px 25px;
                                    padding-right: 8px;
                                    padding-bottom: 4px;
                                    padding-left: 8px;
                                    word-break: break-word;
                                  "
                                >
                                  <div
                                    style="
                                      font-family: Roboto, Arial;
                                      font-size: 12px;
                                      line-height: 1;
                                      text-align: left;
                                      color: #757575;
                                    "
                                  >
                                    ${label}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  align="left"
                                  style="
                                    font-size: 0px;
                                    padding: 10px 25px;
                                    padding-top: 0;
                                    padding-right: 8px;
                                    padding-left: 8px;
                                    word-break: break-word;
                                  "
                                >
                                  <div
                                    style="
                                      font-family: Roboto, Arial;
                                      font-size: 12px;
                                      font-weight: 600;
                                      line-height: 1;
                                      text-align: left;
                                      color: #000000;
                                    "
                                  >
                                    ${value}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>                    
                  </table>
                </div>
`;

export const getEmailTables = (tables) => {
  return tables
    .map((table, i) => {
      const width = TEMPLATE_WIDTH / table.length;
      const widthPercentage = Math.floor((width / TEMPLATE_WIDTH) * 100);

      return `
            <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" bgcolor="#F4F4F4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div
        style="
          background: #f4f4f4;
          background-color: #f4f4f4;
          margin: 0px auto;
          ${i !== 0 ? "margin-top: 8px;" : ""}
          max-width: 600px;
        "
      >
        <table
          align="center"
          border="0"
          cellpadding="0"
          cellspacing="0"
          role="presentation"
          style="background: #f4f4f4; background-color: #f4f4f4; width: 100%"
        >
          <tbody>
            <tr>
              <td
                style="
                  border: 1px solid #e0e0e0;
                  direction: ltr;
                  font-size: 0px;
                  padding: 0;
                  text-align: center;
                "
              >
                ${table
                  .map(({ label, value, dataTestId }, index) =>
                    getEmailTableCell({
                      label,
                      value,
                      dataTestId,
                      width,
                      widthPercentage,
                      index,
                      length: table.length,
                    })
                  )
                  .join("")}
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><![endif]-->
    `;
    })
    .join("");
};
